import { createTheme } from '@mantine/core'

/**
 * UniqPay theme: cool engineered paper, ink text, one cobalt signal accent, hairline structure.
 * Design tokens (OKLCH source -> hex for Mantine):
 *   paper  #f6f8fb  ink #1d2533  muted #5a6578  rule #dde3ec  graphite #1c2230
 * White on brand.6 (#2a57e0) is about 5.9:1.
 * The naira sign is in Geist, Space Grotesk and JetBrains Mono; the system stack is the fallback.
 */
const SYSTEM = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'

const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: 6,

  colors: {
    brand: ['#eef3ff', '#dbe6ff', '#b8cdff', '#8eaeff', '#648cff', '#416df0', '#2a57e0', '#2147bd', '#1b3a99', '#162f7a'],
    graphite: ['#f3f5f8', '#e4e8ee', '#c8cfda', '#a3adbd', '#7d8aa0', '#5a6578', '#414b5e', '#2b3446', '#1c2230', '#121722'],
  },

  white: '#fbfcfe',
  black: '#1d2533',

  fontFamily: `Geist, ${SYSTEM}`,
  fontFamilyMonospace: `"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace`,
  headings: { fontFamily: `"Space Grotesk", Geist, ${SYSTEM}`, fontWeight: '600' },

  defaultRadius: 'sm',
  radius: { xs: '3px', sm: '6px', md: '10px', lg: '14px', xl: '20px' },

  components: {
    Button: { defaultProps: { size: 'md' } },
    TextInput: { defaultProps: { size: 'md' } },
    PasswordInput: { defaultProps: { size: 'md' } },
    NumberInput: { defaultProps: { size: 'md' } },
    Textarea: { defaultProps: { size: 'md' } },
    Select: { defaultProps: { size: 'md' } },
    MultiSelect: { defaultProps: { size: 'md' } },
    FileInput: { defaultProps: { size: 'md' } },
    PinInput: { defaultProps: { size: 'lg' } },
    // Hairline structure, no shadow.
    Card: { defaultProps: { radius: 'md', withBorder: true, padding: 'md' } },
    Paper: { defaultProps: { radius: 'md', withBorder: true } },
    Badge: { defaultProps: { radius: 'sm', variant: 'light' } },
  },
})

export default theme
